export default __webpack_public_path__ + "static/media/close.934ec1bf.svg";